import { render, staticRenderFns } from "./details.vue?vue&type=template&id=21129eac&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=21129eac&prod&lang=less&scoped=true&"
import style1 from "./details.vue?vue&type=style&index=1&id=21129eac&prod&lang=less&scoped=true&"
import style2 from "./details.vue?vue&type=style&index=2&id=21129eac&prod&lang=less&scoped=true&"
import style3 from "./details.vue?vue&type=style&index=3&id=21129eac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21129eac",
  null
  
)

export default component.exports